var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 18v-7a11 11 0 0 0-22 0v7H6v21a9 9 0 0 0 9 9h18a9 9 0 0 0 9-9V18h-7Zm-20-7a9 9 0 0 1 18 0v7H15v-7Zm25 28a7 7 0 0 1-7 7H15a7 7 0 0 1-7-7V20h32v19Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.69 37a1.35 1.35 0 0 0 2.62 0l1.61-5.38a3 3 0 1 0-5.85 0Z"
  })));
};
export default SvgLock;